export const ingredientDefault = {
  alanine: null,
  animal_protein: null,
  arginine: null,
  ash: null,
  aspartic_acid: null,
  base: null,
  c_1null_null: null,
  c_2null_1: null,
  c_2null_3: null,
  c_2null_4: null,
  c_2null_5: null,
  c_2null_null: null,
  c_4_null: null,
  c_6_null: null,
  c_8_null: null,
  c_12_null: null,
  c_14_1: null,
  c_14_null: null,
  c_15_1: null,
  c_15_null: null,
  c_16_1: null,
  c_16_null: null,
  c_17_1: null,
  c_17_null: null,
  c_18_1: null,
  c_18_2: null,
  c_18_3: null,
  c_18_4: null,
  c_18_null: null,
  c_22_1: null,
  c_22_5: null,
  c_22_6: null,
  calcium: null,
  calories: 0,
  carbohydrate_exchanger: 0,
  carbohydrates: 0,
  carbohydrates_energy: null,
  carbohydrates_total: 0,
  carotene_beta: null,
  category: 1,
  cholesterol: null,
  copper: null,
  cystine: null,
  energy_value_according_regulation_kcal: null,
  energy_value_according_regulation_kj: null,
  energy_value_kj: null,
  fat: 0,
  fat_energy: null,
  fiber: 0,
  fiber_energy: null,
  folate_total: null,
  fructose: null,
  glucose: null,
  glutamic_acid: null,
  glycemic_index: null,
  glycine: null,
  grams: 1,
  group: [],
  histidine: null,
  iodine: null,
  iron: null,
  is_diary_free: false,
  is_gluten_free: false,
  is_public: false,
  is_super_food: false,
  is_vegan: false,
  is_vegetarian: false,
  isoleucine: null,
  jnkt: null,
  lactose: null,
  leucine: null,
  lysine: null,
  magnesium: null,
  manganese: null,
  manufacturer: null,
  measurement: 1,
  methionine: null,
  n_3: null,
  n_6: null,
  name: '',
  niacin: null,
  nkt: null,
  phenylalanine: null,
  phosphorus: null,
  plant_protein: null,
  potassium: null,
  price: null,
  proline: null,
  protein: 0,
  protein_according_regulation: null,
  protein_energy: null,
  protein_fat_exchangers: null,
  retinol: null,
  riboflavin: null,
  salt: null,
  serine: null,
  sodium: null,
  starch: null,
  sucrose: null,
  thiamin: null,
  threonine: null,
  tryptophan: null,
  tyrosine: null,
  user: null,
  valine: null,
  vitamin_A_RAE: null,
  vitamin_B_12: null,
  vitamin_B6: null,
  vitamin_C: null,
  vitamin_D: null,
  vitamin_E: null,
  waste: null,
  water: null,
  wnkt: null,
  zinc: null,
}

export const basicIngredientNutrients = [
  'calories',
  'protein',
  'fat',
  'carbohydrates_total',
  'carbohydrates',
  'fiber',
  'carbohydrate_exchanger',
] as const

// 97 elements
export const specificIngredientNutrients = [
  // Podstawowe składniki odżywcze
  'energy_value_kj',
  'energy_value_according_regulation_kcal',
  'energy_value_according_regulation_kj',
  'animal_protein',
  'plant_protein',
  'protein_according_regulation',
  // Składniki mineralne
  'sodium',
  'potassium',
  'calcium',
  'phosphorus',
  'magnesium',
  'iron',
  'zinc',
  'copper',
  'iodine',
  'manganese',
  // Witaminy
  'thiamin',
  'riboflavin',
  'niacin',
  'folate_total',
  'vitamin_B_12',
  'vitamin_B6',
  'vitamin_A_RAE',
  'vitamin_C',
  'vitamin_D',
  'vitamin_E',
  'carotene_beta',
  'retinol',
  // Aminokwasy;
  'isoleucine',
  'leucine',
  'lysine',
  'methionine',
  'cystine',
  'phenylalanine',
  'tyrosine',
  'threonine',
  'tryptophan',
  'valine',
  'arginine',
  'histidine',
  'alanine',
  'aspartic_acid',
  'glutamic_acid',
  'glycine',
  'proline',
  'serine',
  // Kwasy tłuszczowe
  'c_4_0',
  'c_6_0',
  'c_8_0',
  'c_10_0',
  'c_12_0',
  'c_14_0',
  'c_15_0',
  'c_16_0',
  'c_17_0',
  'c_18_0',
  'c_20_0',
  'nkt',
  'c_14_1',
  'c_15_1',
  'c_16_1',
  'c_17_1',
  'c_18_1',
  'c_20_1',
  'c_22_1',
  'jnkt',
  'c_18_2',
  'c_18_3',
  'c_18_4',
  'c_20_3',
  'c_20_4',
  'c_20_5',
  'c_22_5',
  'c_22_6',
  'wnkt',
  'n_6',
  'n_3',
  'cholesterol',
  // Inne
  'waste',
  'water',
  'sucrose',
  'lactose',
  'starch',
  'ash',
  'salt',
  'glucose',
  'fructose',
  // 'protein_energy',
  // 'fat_energy',
  // 'carbohydrates_energy',
  'glycemic_index',
  'protein_fat_exchangers',
] as const

export const getIngredientBaseName = (ingredientBase = '') => {
  if (ingredientBase) {
    return ingredientBase
  } else {
    return 'Kcalmar.pro'
  }
}
